var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2804_22487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4619 14.9615C23.4619 15.8796 23.0972 16.76 22.448 17.4092C21.7988 18.0584 20.9183 18.4231 20.0003 18.4231C19.0822 18.4231 18.2017 18.0584 17.5526 17.4092C16.9034 16.76 16.5387 15.8796 16.5387 14.9615C16.5387 14.0435 16.9034 13.163 17.5526 12.5139C18.2017 11.8647 19.0822 11.5 20.0003 11.5C20.9183 11.5 21.7988 11.8647 22.448 12.5139C23.0972 13.163 23.4619 14.0435 23.4619 14.9615ZM13.078 27.9935C13.1077 26.1772 13.85 24.4454 15.145 23.1714C16.4399 21.8975 18.1837 21.1835 20.0003 21.1835C21.8168 21.1835 23.5606 21.8975 24.8556 23.1714C26.1505 24.4454 26.8929 26.1772 26.9225 27.9935C24.7509 28.9893 22.3894 29.5032 20.0003 29.5C17.5301 29.5 15.1854 28.9609 13.078 27.9935Z",
    stroke: "#1D45D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2804_22487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5f311d2c0a363029a9aa3f6fcdcd71d9.svg";
export { ForwardRef as ReactComponent };